<script lang="jsx">
  export default {
    props: {
      visible: Boolean
    },
    methods: {
      renderCancelBtn () {
        // CP4.4: Vue-3 JSX — `class` not `className`; el-button onClick is fine.
        return (
          <el-button class="exit-modal-btn" onClick={() => this.$emit('isVisible', false)}>
            Cancel
          </el-button>
        )
      },
      renderYesBtn () {
        return (
          <el-button class="exit-modal-btn" type="primary" onClick={() => this.$emit('goBack', true)}>
            Yes
          </el-button>
        )
      }
    },
    render () {
      // CP4.4: el-dialog opens via `modelValue` (was element-ui `visible`); JSX slots use `v-slots`
      // (the `<template v-slot:footer>` form is not supported by @vue/babel-plugin-jsx).
      return (
        <el-dialog
          title="Confirm cancellation"
          modelValue={this.visible}
          width="30%"
          show-close={false}
          close-on-press-escape={false}
          close-on-click-modal={false}
          v-slots={{
            footer: () => (
              <span class="dialog-footer">
                {this.renderCancelBtn()}
                {this.renderYesBtn()}
              </span>
            )
          }}>
          <span>Leaving while the transaction is saving could cause data loss. Do you wish to proceed?</span>
        </el-dialog>
      )
    }
  }
</script>
